import type { InvoiceComment } from "@/apis/gql/types";
import { useSession } from "@/lib/auth/auth";
import { cn } from "@/lib/utils";

import { useRef } from "react";
import { useEffect } from "react";
import { Comment } from "./comment";

type Props = {
  comments: InvoiceComment[];
  className?: React.HTMLAttributes<HTMLDivElement>["className"];
};

export const InvoiceComments = ({ comments, className }: Props) => {
  const { data: session } = useSession();

  const containerRef = useRef<HTMLDivElement>(null);

  // biome-ignore lint/correctness/useExhaustiveDependencies: is needed to scroll to the bottom of the comments
  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [comments]);

  return (
    <div ref={containerRef} className={cn("flex flex-col gap-2", className)}>
      {comments.map((comment) => (
        <Comment
          key={comment.invoiceCommentId}
          comment={comment}
          self={comment.userId === session?.user?.id}
        />
      ))}
    </div>
  );
};
